import { TableColumn } from "../table/TableColumn";

const EnrolmentRelationshipColumns: TableColumn[] = [
    {
        heading: "Name",
        accessor: "name",
        isNumeric: false,
        id: 0,
        sortByName: "asset.mstDisplayname",
        sortDirection: "asc",
        active: true,
        translationKey: "name"
    },
    {
        heading: "Unique Idenifier",
        accessor: "masterByMasterAssetUniqueIdentifier",
        isNumeric: false,
        id: 1,
        sortByName: "asset.mstIdnumber",
        sortDirection: "asc",
        active: true,
        translationKey: "uniqueIdentifier"
    },
    //Just commented it out so that we don't forget it. Investigation needs to be done on this
    // {
    //     heading: "Type",
    //     accessor: "type",
    //     isNumeric: false,
    //     id: 2,
    //     sortByName: "atpName",
    //     sortDirection: "asc",
    //     active: false
    // },
    {
        heading: "Date Linked",
        accessor: "dateLinked",
        isNumeric: false,
        id: 3,
        sortByName: "maStartDatetime",
        sortDirection: "asc",
        active: true,
        translationKey: "dateLinked"
    }
]

export default EnrolmentRelationshipColumns;
